// extracted by mini-css-extract-plugin
export default {"h1":"H1_h1__9ggQM","h1--align-start":"H1_h1--align-start__4NKuD","h1--align-center":"H1_h1--align-center__pFEhP","h1--align-end":"H1_h1--align-end__Iv74M"};